












import Vue from "vue";
import Component from "vue-class-component";
import { Provide } from "vue-property-decorator";
import { ICellRendererParams } from "ag-grid-community";
import { IPromotionGridModel } from "../../models";

@Component
export default class PromotionPreviewButton extends Vue {
    @Provide("params")
    params!: ICellRendererParams;

    get model(): IPromotionGridModel {
        return this.params.data as IPromotionGridModel;
    }
}
